import { render, staticRenderFns } from "./QuickPay.vue?vue&type=template&id=bf50e9c6"
import script from "./QuickPay.vue?vue&type=script&lang=ts"
export * from "./QuickPay.vue?vue&type=script&lang=ts"
import style0 from "./QuickPay.vue?vue&type=style&index=0&id=bf50e9c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports